<div class="one-dialog">
    <div class="dialog-header d-flex">
        <div class="title flex-grow-1">
            <h2 mat-dialog-title>{{title}}</h2>
        </div>
        <div class="right">
            <button mat-icon-button mat-dialog-close aria-label="Close dialog icon">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="search-box">
            <mat-form-field class="full" appearance="legacy">
                <mat-label>Nhập để tìm kiếm</mat-label>
                <input matInput placeholder="Nhập tên người dùng" [formControl]="userCtrl">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <div class="users">
            <user-info-item [user]="user" *ngFor="let user of filteredUsers"
                            (clicked)="onUserSelected($event)"></user-info-item>
        </div>
    </mat-dialog-content>
</div>